//require('./components/PostList.scss');
require('intersection-observer');

import Vue from 'vue';
//import router from './router';

import FrontSearcherEmployee from './FrontSearcherEmployee.vue';

import BlogArchive from './BlogArchive.vue';
import ExpertiseArchivesArticles from './ExpertiseArchivesArticles.vue';
import EventsArchive from './EventsArchive.vue';
import HomeSearchEmployee from './HomeSearchEmployee.vue';
import Employees from './Employees.vue';
import Search from './Search.vue';
import VueLazyload from 'vue-lazyload'
import VueObserveVisibility from 'vue-observe-visibility'
Vue.use(VueObserveVisibility)
//import WooAddToCart from './wooAddVariable';
Vue.use(VueLazyload)


//import moment from 'moment';
import Blazy from 'blazy';
//import axios from 'axios';

//import _get from 'lodash.get';
import { TweenMax, TimelineMax } from "gsap";

import localforage from '../localgorgeConfig';

Vue.config.productionTip = true;

Vue.mixin({
	methods: {
		loadLocalStorage() {
			const self = this;
			return localforage.getItem('loadEmployees_' + theme_data.language)
				.catch(function (err) {
					console.log('cant Get data from local forge ', err);
				});
		},
		saveLocalForge(employees, version) {
			const data = {
				'employees': employees,
				'version': version,
			}
			return localforage.setItem(
				'loadEmployees_' + theme_data.language,
				data)
				.catch((err) => {
					console.log('Some error during local forge save: ', err);
				})
		},

		enterAnimationListStagged(el, done) {

			let self = this;
			let index = parseInt(el.dataset.index);
			let delay = index * 150

			const tm = new TimelineMax({
			});
			tm.set(el, {
				scale: 0.9,
				opacity: -1,
				y: 200,
				//height: '0%',
				transformOrigin: '50% 50%',
				ease: Back.easeInOut.config(0.3),
			});

			setTimeout(function () {
				tm.to(el, 0.6, {
					opacity: 1,
					y: 0,
					//height: '100%',
					onCompleteParams: ["{self}"],
					onComplete: function (ele) {
						done;
						TweenMax.to(ele.target, 0.6, { scale: 1 }, '+=0.5')
					}
				});
				//tm.timeScale(0.2);
			}, delay);


		},
		leaveAnimationListStagged(el, done) {

			let self = this;
			let index = parseInt(el.dataset.index);
			let delay = index * 150
			const tm = new TimelineMax({
			});
			tm.set(el, {
				scale: 1,
				opacity: 1,
				transformOrigin: '50% 50%',
				ease: Back.easeOut.config(1),
			});
			setTimeout(function () {
				tm.to(el, 1, {
					scale: 0,
					height: 0,
					opacity: 0,
					onComplete: done
				});
			}, delay);
		},
	}
});


const BlogArchiveDOM = document.getElementById("BlogArchive");
if (document.body.contains(BlogArchiveDOM)) {
	new Vue({
		//mixins: [helpers],
		el: '#BlogArchive',
		template: '<BlogArchive/>',
		//router,
		components: {
			BlogArchive
		},
	});
}

const ExpertiseArchivesArticlesDOM = document.getElementById("archive-expertise-articles");
if (document.body.contains(ExpertiseArchivesArticlesDOM)) {
	new Vue({
		//mixins: [helpers],
		el: '#archive-expertise-articles',
		template: '<ExpertiseArchivesArticles/>',
		//router,
		components: {
			ExpertiseArchivesArticles
		},
	});
}

const EventsArchiveDOM = document.getElementById("EventsArchive");
if (document.body.contains(EventsArchiveDOM)) {
	new Vue({
		//mixins: [helpers],
		el: '#EventsArchive',
		template: '<EventsArchive/>',
		//router,
		components: {
			EventsArchive
		},
	});
}

const HomeSearchEmployeeDOM = document.getElementById("HomeSearchEmployee");

if (document.body.contains(HomeSearchEmployeeDOM)) {
	new Vue({
		//mixins: [helpers],
		el: '#HomeSearchEmployee',
		template: '<HomeSearchEmployee/>',
		//router,
		components: {
			HomeSearchEmployee
		},
	});
}

const EmployeesDOM = document.getElementById("Employees");

if (document.body.contains(EmployeesDOM)) {
	new Vue({
		//mixins: [helpers],
		el: '#Employees',
		template: '<Employees/>',
		//router,
		components: {
			Employees
		},
	});
}

const SearchDOM = document.getElementById("Search");

if (document.body.contains(SearchDOM)) {
	new Vue({
		//mixins: [helpers],
		el: '#Search',
		template: '<Search/>',
		//router,
		components: {
			Search
		},
	});
}



// WEBPACK FOOTER //
// ./src/js/vue/main_app.js